const doc = [({"errors":({"logo":"Error uploading logo. Please try again.", "image":"Error uploading image. Please try again."})})];
module.exports = doc.length <= 1 ? doc[0] : doc;